/* ══════════════════════════════════════════════════════════════════════
   BID Motion Layer — site-wide micro-interactions
   Loaded with `defer` from layout/theme.liquid. No dependencies. ES5.

   WHAT'S IN HERE (for future devs/AI):
   1. SCROLL REVEAL — elements fade/slide in as they enter the viewport.
      - Add class "bid-reveal" to ANY element to opt in manually.
      - AUTO_SECTIONS below get the class automatically (section-level).
      - AUTO_CARDS get it per-card with a stagger delay (--bid-d index).
      - CSS lives in assets/bid-shared.css (search "MOTION LAYER").
   2. HOLO TILT — TCG-style 3D tilt + holographic shine that follows the
      cursor on Top Cards (.pfs-topcard). Injects a .bid-holo-shine child.
      Desktop + fine pointers only; never on touch.

   Both honor prefers-reduced-motion (everything stays static).
   To extend: add selectors to the arrays below — do NOT copy this logic
   into individual sections.
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ────────────────────────── 1. SCROLL REVEAL ───────────────────────── */
  var AUTO_SECTIONS = [
    '.bid-mq',                 /* marquee ticker                     */
    '.bhs__head', '.bhs__info', '.bhs__sealed' /* home spotlight    */
  ];
  var AUTO_CARDS = ['.bento__tile', '.bhs-card', '.pg2-card', '.bch-tile', '.bch-card', '.bch-pick'];

  function setupReveal() {
    if (reduced || !('IntersectionObserver' in window)) return;

    AUTO_SECTIONS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.classList.add('bid-reveal');
      });
    });
    AUTO_CARDS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el, i) {
        el.classList.add('bid-reveal');
        el.style.setProperty('--bid-d', i % 8); /* stagger, capped at 8 steps */
      });
    });

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    document.querySelectorAll('.bid-reveal').forEach(function (el) { obs.observe(el); });
  }

  /* ────────────────────────── 2. HOLO TILT ───────────────────────────── */
  var TILT_SELECTOR = '.bhs-card, .pg2-card, .pp2__card';
  var MAX_TILT = 7; /* degrees */

  function setupTilt() {
    if (reduced) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    document.querySelectorAll(TILT_SELECTOR).forEach(function (card) {
      if (card.dataset.bidTilt) return;
      card.dataset.bidTilt = '1';

      /* holographic shine overlay (position driven by --hx / --hy) */
      var shine = document.createElement('div');
      shine.className = 'bid-holo-shine';
      card.appendChild(shine);

      /* PERF: throttle style writes to one per animation frame */
      var pending = false, lastE = null;
      function paint() {
        pending = false;
        if (!lastE) return;
        var r = card.getBoundingClientRect();
        var px = (lastE.clientX - r.left) / r.width;   /* 0..1 */
        var py = (lastE.clientY - r.top) / r.height;
        var rx = (0.5 - py) * MAX_TILT;                /* tilt away from cursor */
        var ry = (px - 0.5) * MAX_TILT;
        card.style.transform =
          'perspective(900px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) +
          'deg) translateY(-4px) scale(1.015)';
        card.style.setProperty('--hx', (px * 100).toFixed(1) + '%');
        card.style.setProperty('--hy', (py * 100).toFixed(1) + '%');
      }
      card.addEventListener('mousemove', function (e) {
        lastE = e;
        if (!pending) { pending = true; requestAnimationFrame(paint); }
      });
      card.addEventListener('mouseleave', function () {
        lastE = null;
        card.style.transform = ''; /* fall back to the section's own hover CSS */
      });
    });
  }

  function boot() { setupReveal(); setupTilt(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
